var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.781,
    height: 18.388,
    viewBox: "0 0 20.781 18.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .homeA {\n                fill: #253e58;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.437 -16.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "homeA",
    d: "M23.553,45.49a.555.555,0,0,0-.553.553v9.269a.555.555,0,0,0,.553.553h4.7a.555.555,0,0,0,.553-.553V50.057h3.319v5.255a.555.555,0,0,0,.553.553H37.66a.555.555,0,0,0,.553-.553V46.043a.553.553,0,1,0-1.106,0v8.716H33.234V49.5a.555.555,0,0,0-.553-.553H28.255a.555.555,0,0,0-.553.553v5.255h-3.6V46.043A.553.553,0,0,0,23.553,45.49Z",
    transform: "translate(-7.641 -20.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "homeA",
    d: "M33.034,25.5,23.2,16.661a.554.554,0,0,0-.739,0L12.62,25.5a.552.552,0,1,0,.739.822l9.468-8.511,9.468,8.511a.552.552,0,1,0,.739-.822Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.33135d4c.svg";
export { ForwardRef as ReactComponent };